module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAe0lEQVR42u3aMQ2AUBRD0ecBEUy4QA0OGb8wUhKQ0TPcpPOZO0mmuQEAAAAAAAAAAAAAoBzgubc0BQAAAAAAAAAAAAAAAAD/uM40BQAAAAAAAAAAAAAAAABfaz/SFAAAAAAAAAAAAAAAAAAAcJQEAAAAAAAAAAAAAKCuF/ipNJVP4JWrAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Lithuania.png
// module id = SWeA
// module chunks = 0 62 63